export type IntegrationModel = {
  access_token: string,
  cache_key: number,
  data: any,
  dates: any,
  id: number,
  integrable_id: number,
  integrable_type: string,
  service_provider: string,
}

export type IntegrationRequestOptions = {}

const state = {
  access_token: '',
  data: {},
  id: null,
  integrable_id: undefined,
  integrable_type: '',
  service_provider: '',
}

export const requiredFields = [
  { key: 'integrable_id' },
  { key: 'integrable_type' },
  { key: 'service_provider' },
]

export default state
